/**
 * Pointer capture, guarded the same way at every call site: some
 * environments (and jsdom) have no pointer capture, and a drag/stroke still
 * works as long as the pointer stays over the element, so a failure here is
 * never fatal — just swallow it.
 */
export function capturePointer(target: Element, pointerId: number): void {
  try {
    target.setPointerCapture(pointerId);
  } catch {
    // Some environments (and jsdom) have no pointer capture; the drag/stroke
    // still works as long as the pointer stays over the element.
  }
}

export function releasePointer(target: Element, pointerId: number): void {
  try {
    if (target.hasPointerCapture(pointerId)) target.releasePointerCapture(pointerId);
  } catch {
    // Some environments (and jsdom) have no pointer capture; the drag/stroke
    // still works as long as the pointer stays over the element.
  }
}
